import { PREFERENCES_ROUTES } from '../../constants/_routes'
import preferencesTypes from '../../constants/preferencesTypes'
import { axios } from '../../services'

const update_preferences_request = () => {
  return {
    type: preferencesTypes.update.request
  }
}

const update_preferences_success = (response) => {
  return {
    type: preferencesTypes.update.success,
    payload: response.data
  }
}

const update_preferences_failure = (messages) => {
  return {
    type: preferencesTypes.update.failure,
    payload: messages
  }
}

const update_preferences = (values) => {
  return function (dispatch) {
    // Before Request
    dispatch(update_preferences_request())

    // Request
    axios.post(
      PREFERENCES_ROUTES.update,
      values
    ).then( response => {
      // success
      dispatch( update_preferences_success(response) )

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error updating preference."]
      }
      // dispatch( try_force_logoff(error.response) )
      window.showSnackbar('error', errors)
      dispatch( update_preferences_failure(errors))
    })
  }

}

export {
  update_preferences
}



// WEBPACK FOOTER //
// ./src/js/actions/preferences/update.js